import { useMutation, useQuery } from "react-query";
import isEmpty from "lodash/isEmpty";
import omit from "lodash/omit";
import reject from "lodash/reject";

import { gwtClient } from "@monta/utils";

import type { QueryKey } from "react-query";
import type {
  GetEducationPackExamResults,
  GetFindSupplementaryExamResult,
  GetMainResultSetKonkoor
} from "./exam-results.types";

export const getEducationPackExamResult = {
  url: () => `/exam/getEducationPackExamResult`,
  fn: async (request: GetEducationPackExamResults["request"]) => {
    const { data } = await gwtClient<GetEducationPackExamResults["response"]>({
      ...request?.axiosConfig,
      method: "POST",
      url: getEducationPackExamResult.url(),
      data: request.body
    });
    return data;
  },
  key: (request: GetEducationPackExamResults["request"]) => {
    return reject(
      [getEducationPackExamResult.url(), omit(request ?? {}, "axiosConfig")],
      isEmpty
    ) as QueryKey;
  },
  query: (options: GetEducationPackExamResults["queryOptions"]) => ({
    ...options.queryOptions,
    queryKey: getEducationPackExamResult.key(options.request),
    queryFn: () => getEducationPackExamResult.fn(options.request)
  }),
  useQuery: (options: GetEducationPackExamResults["queryOptions"]) =>
    useQuery(getEducationPackExamResult.query(options)),
  useMutation: (options?: GetEducationPackExamResults["mutationOptions"]) =>
    useMutation({
      ...options,
      mutationFn: getEducationPackExamResult.fn
    })
};

export const getMainResultSetKonkoor = {
  url: () => `/EducationPack/getMainResultSetKonkoor`,
  fn: async (request: GetMainResultSetKonkoor["request"]) => {
    const { data } = await gwtClient<GetMainResultSetKonkoor["response"]>({
      ...request?.axiosConfig,
      method: "POST",
      url: getMainResultSetKonkoor.url(),
      data: request.body
    });
    return data;
  },
  key: (request: GetMainResultSetKonkoor["request"]) => {
    return reject(
      [getMainResultSetKonkoor.url(), omit(request ?? {}, "axiosConfig")],
      isEmpty
    ) as QueryKey;
  },
  query: (options: GetMainResultSetKonkoor["queryOptions"]) => ({
    ...options.queryOptions,
    queryKey: getMainResultSetKonkoor.key(options.request),
    queryFn: () => getMainResultSetKonkoor.fn(options.request)
  }),
  useQuery: (options: GetMainResultSetKonkoor["queryOptions"]) =>
    useQuery(getMainResultSetKonkoor.query(options)),
  useMutation: (options?: GetMainResultSetKonkoor["mutationOptions"]) =>
    useMutation({
      ...options,
      mutationFn: getMainResultSetKonkoor.fn
    })
};

export const getFindSupplementaryExamResult = {
  url: () => `/exam/findSupplementaryExamResult`,
  fn: async (request: GetFindSupplementaryExamResult["request"]) => {
    const { data } = await gwtClient<
      GetFindSupplementaryExamResult["response"]
    >({
      ...request?.axiosConfig,
      method: "POST",
      url: getFindSupplementaryExamResult.url(),
      data: request.body
    });
    return data;
  },
  key: (request: GetFindSupplementaryExamResult["request"]) => {
    return reject(
      [
        getFindSupplementaryExamResult.url(),
        omit(request ?? {}, "axiosConfig")
      ],
      isEmpty
    ) as QueryKey;
  },
  query: (options: GetFindSupplementaryExamResult["queryOptions"]) => ({
    ...options.queryOptions,
    queryKey: getFindSupplementaryExamResult.key(options.request),
    queryFn: () => getFindSupplementaryExamResult.fn(options.request)
  }),
  useQuery: (options: GetFindSupplementaryExamResult["queryOptions"]) =>
    useQuery(getFindSupplementaryExamResult.query(options)),
  useMutation: (options?: GetFindSupplementaryExamResult["mutationOptions"]) =>
    useMutation({
      ...options,
      mutationFn: getFindSupplementaryExamResult.fn
    })
};
